import { createUseStyles } from 'react-jss'

export const useStyle = createUseStyles({
  link: {
    marginLeft: 34
  }
})
